import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SidenavService } from 'src/app/shared/sidenav-bar/sidenav.service';
import { LocaleService } from 'src/app/shared/services/translate.service';
import { AuthServiceService } from 'src/app/shared/services/auth-service.service';
import { ConnectionService } from '../../organization/connection.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from "src/environments/environment";
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-guest',
    templateUrl: './guest.component.html',
    styleUrls: ['./guest.component.scss'],
    standalone: false
})
export class GuestComponent implements OnInit {

  productsScorecardConfig: any = {}
  customersScorecardConfig: any = {}
  ratingScorecardConfig: any = {}

  show: boolean = false;
  appiworksLogo: string = "https://storage.googleapis.com/jivrus-web-images/products/appiworks/appiworks-logo.png";
  loginFailed: boolean;
  constructor(
    private matDialog: MatDialog,
    public sidenavService: SidenavService,
    public translate: TranslateService,
    private localeService: LocaleService,
    public authService: AuthServiceService,
    public connectionService: ConnectionService,
    public router: Router,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,

  ) {
    this.translate.use(this.localeService.currentLocale);
  }

  ngOnInit(): void {
    console.log("Environment in guest", environment.env, environment?.build_number)
    this.createScorecardConfig()
    this.loginFailed = false;

    // this.route.queryParams.subscribe(params => {

    // });
    if (!this.authService.loggedIn) {
      this.authService.authCheck(true)
      this.authService.authCheckPositive.subscribe(res => {
        console.log("Auth check result in guest", res);
        // this.connectionService.getPreAuthenticatedToken();
        this.connectionService.getWorkSpaceId();
        if (res) {
          if( this.authService.navigateParams?.entityType == 'flow-signup'){
            this.router.navigate(['flow', 'sign-up'], { queryParams: this.authService.navigateParams})
          } else {
            this.router.navigate(['home'], {queryParams: this.authService.navigateParams});
          }

        }
        // else {
        //   this._snackBar.open('Apologies, the login attempt failed. Please reload the page and try logging in again.', 'ok', {
        //     horizontalPosition: 'center',
        //     verticalPosition: 'top',
        //   });
        // }
      })
    }

    this.authService.onGuestPage = true;
  }

  createScorecardConfig(){
    ['integrations', 'clients', 'rating'].forEach(type => {
      let config = {
        config: {
          dataSource: {
            dataSourceType: 'static',
            staticData: []
          }
        }
      }
      if(type == 'integrations'){
        config.config.dataSource.staticData.push(...['Integrations', '50+'])
        this.productsScorecardConfig = config
      }else if(type == 'clients'){
        config.config.dataSource.staticData.push(...['Client platforms', '6+'])
        this.customersScorecardConfig = config
      }else if(type == 'rating'){
        config.config.dataSource.staticData.push(...['Templates', '20+'])
        this.ratingScorecardConfig = config
      }
    })
  }

}
